<div [ngClass]="(dialogRef ? 'direct_popup' : 'right_sec')">
  <div class="main_inner">
    <div class="chat-area">
      <div class="chat-main-area">
        <div class="chat-header">
          <div class="back-area">
            <span class="material-icons" (click)="closeChatDialog()">
              keyboard_arrow_left
            </span>
          </div>
          <div
            class="d-flex user-pic-name align-items-center justify-content-between w-full"
          >
            <div class="d-flex align-items-center">
              <div class="user-images">
                <img
                  *ngIf="data.userInfo.profileUrl !== ' '"
                  src="{{ data.userInfo.profileUrl }}"
                  onError="this.onerror=null;this.src='../../../../../../assets/images/person-ic.jpg';"
                  alt="profile-image"
                />
                <img
                  *ngIf="data.userInfo.profileUrl === ' '"
                  src="assets/images/person-ic.jpg"
                  onError="this.onerror=null;this.src='../../../../../../assets/images/person-ic.jpg';"
                  alt="profile-image"
                />
              </div>
              <div>
                <strong>{{ data.userInfo.company }}</strong>
              </div>
            </div>
            <div
              class="relative group-info-wrapper d-flex align-items-center gap-16 mr-3"
            >
              <span
                class="material-icons group-info-icon"
                (click)="toggleGroupInfo()"
                title="People"
              >
                group
              </span>
              <span
                class="material-icons group-info-icon"
                (click)="toggleSearchPanel()"
                title="Search"
              >
                search
              </span>
              <span
                *ngIf="!data.staff && isShipper"
                class="material-icons group-info-icon"
                (click)="toggleContractPanel()"
                title="Contract Info"
              >
                description
              </span>
            </div>
          </div>
        </div>
        <div class="d-flex w-100">
          <div class="chat-main">
            <div class="chat-loader-overlay" *ngIf="isLoading">
              <mat-spinner diameter="40"></mat-spinner>
              <span>Loading messages…</span>
            </div>
            <div
              class="chat-inner-box"
              #scrollMe
              (scroll)="onContainerScroll()"
            >
              <div
                class="user-chat"
                *ngFor="let item of groupedMessages; trackBy: trackByDate"
              >
                <div class="chat-date">
                  <span>{{ item.date }}</span>
                </div>
                <div
                  class="user-chat-row"
                  *ngFor="let chat of item.messages; let i = index"
                  [class.own-message]="chat.isOwn"
                  [attr.id]="'message-' + chat.id"
                >
                  <div
                    class="left-chat-message"
                    *ngIf="chat?.userName != loggedInUsername"
                  >
                    <div class="user-images">
                      <img
                        [src]="chat.senderProfileImage"
                        *ngIf="shouldShowAvatar(item.messages, i)"
                        onerror="
                          this.onerror = null;
                          this.src = 'assets/images/person-ic.jpg';
                        "
                        alt=""
                      />
                    </div>

                    <!-- MESSAGE CONTENT -->
                    <div class="chat-text">
                      <div
                        class="message-header"
                        *ngIf="shouldShowUserName(item.messages, i)"
                      >
                        <strong class="name">{{ chat.userName }}</strong>
                      </div>

                      <div
                        class="message-bubble other-bubble date-chat message-wrapper"
                      >
                        <div
                          class="reply-preview"
                          *ngIf="
                            chat.metadata?.replyTo && !chat.metadata?.isDeleted
                          "
                        >
                          <small class="reply-user">
                            Reply to {{ chat.metadata.replyTo.senderName }}
                          </small>
                          <div class="reply-text">
                            {{ chat.metadata.replyTo.message }}
                          </div>
                        </div>
                        <ng-container *ngIf="editingMessageId !== chat.id">
                          <div class="d-flex gap-2 w-100">
                            <div
                              class="bubble-footer"
                              *ngIf="!chat.metadata?.isDeleted"
                            >
                              <span
                                class="material-icons more-icon"
                                [matMenuTriggerFor]="mainMenu"
                              >
                                more_vert
                              </span>
                            </div>
                            <!-- ATTACHMENT IMAGE -->
                            <div
                              class="chat-attachment chat-image"
                              *ngIf="isImageMessage(chat)"
                            >
                              <img
                                [src]="getAttachmentImageSrc(chat)"
                                (error)="onImageError($event, chat)"
                                alt="attachment"
                              />
                              <span
                                class="material-icons attachment-download"
                                (click)="downloadAttachment(chat)"
                                title="Download"
                              >
                                file_download
                              </span>
                              <span class="attachment-name">{{
                                chat.metadata.attachment.name
                              }}</span>
                            </div>
                            <!-- ATTACHMENT FILE -->
                            <div
                              class="chat-attachment chat-file"
                              *ngIf="isFileMessage(chat)"
                              (click)="downloadAttachment(chat)"
                              title="Download {{ chat.metadata.attachment.name | fileDisplayName }}"
                            >
                              <img
                                class="chat-file-icon"
                                [src]="(chat?.metadata?.attachment?.name || chat?.metadata?.attachment?.key) | fileTypeIcon"
                                alt="file icon"
                              />
                              <div class="chat-file-info">
                                <p class="chat-file-name">
                                  {{ chat.metadata.attachment.name | fileDisplayName }}
                                </p>
                                <small class="chat-file-size">{{
                                  formatFileSize(
                                    chat.metadata.attachment.size
                                  )
                                }}</small>
                              </div>
                              <span class="material-icons chat-file-download"
                                >file_download</span
                              >
                            </div>
                            <!-- TEXT MESSAGE -->
                            <p
                              class="message-text"
                              *ngIf="isTextMessage(chat)"
                              [ngClass]="{
                                'editing-text': chat.metadata?.isDeleted,
                              }"
                            >
                              {{ chat.message }}
                              <small
                                *ngIf="
                                  chat.metadata?.edited &&
                                  !chat.metadata?.isDeleted
                                "
                              >
                                (edited)
                              </small>
                            </p>
                          </div>
                          <!-- MAIN MENU -->
                          <mat-menu
                            #mainMenu="matMenu"
                            xPosition="after"
                            yPosition="below"
                          >
                            <button
                              mat-menu-item
                              (click)="startReplyMessage(chat)"
                              class="menu-button-own-chat"
                            >
                              Reply
                            </button>
                            <button
                              mat-menu-item
                              *ngIf="!chat.metadata?.isDeleted"
                              class="menu-button-own-chat"
                              (click)="copyMessage(chat)"
                            >
                              <span>Copy</span>
                            </button>
                            <button
                              mat-menu-item
                              *ngIf="isImageMessage(chat) || isFileMessage(chat)"
                              (click)="downloadAttachment(chat)"
                              class="menu-button-own-chat"
                            >
                              <span>Download</span>
                            </button>
                          </mat-menu>

                          <!-- READ BY SUB MENU -->
                          <mat-menu
                            #readByMenu="matMenu"
                            xPosition="after"
                            yPosition="above"
                          >
                            <div
                              class="read-by-item"
                              *ngFor="let seen of chat.seenBy"
                            >
                              {{ seen.name }}
                            </div>
                          </mat-menu>
                        </ng-container>
                      </div>
                      <div
                        class="date-chat"
                        *ngIf="shouldShowTime(item.messages, i)"
                      >
                        <span class="time-text">
                          {{ chat.messageDate | date: "shortTime" }}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div
                    class="right-chat-message"
                    *ngIf="chat?.userName == loggedInUsername"
                  >
                    <!-- MESSAGE CONTENT -->
                    <div class="own-messafe-content d-flex align-items-end">
                      <div class="chat-text">
                        <div class="message-bubble own-bubble message-wrapper">
                          <!-- REPLIED MESSAGE PREVIEW -->
                          <div
                            class="reply-preview"
                            *ngIf="
                              chat.metadata?.replyTo &&
                              !chat.metadata?.isDeleted
                            "
                          >
                            <small class="reply-user">
                              Reply to {{ chat.metadata.replyTo.senderName }}
                            </small>
                            <div class="reply-text">
                              {{ chat.metadata.replyTo.message }}
                            </div>
                          </div>
                          <ng-container
                            *ngIf="
                              editingMessageId !== chat.id;
                              else editingState
                            "
                          >
                            <div class="d-flex justify-content-between w-100">
                              <!-- ATTACHMENT IMAGE -->
                              <div
                                class="chat-attachment chat-image"
                                *ngIf="isImageMessage(chat)"
                              >
                                <img
                                  [src]="getAttachmentImageSrc(chat)"
                                  (error)="onImageError($event, chat)"
                                  alt="attachment"
                                />
                                <span
                                  class="material-icons attachment-download"
                                  (click)="downloadAttachment(chat)"
                                  title="Download"
                                >
                                  file_download
                                </span>
                                <span class="attachment-name">{{
                                  chat.metadata.attachment.name
                                }}</span>
                              </div>
                              <!-- ATTACHMENT FILE -->
                              <div
                                class="chat-attachment chat-file"
                                *ngIf="isFileMessage(chat)"
                                (click)="downloadAttachment(chat)"
                                title="Download {{ chat.metadata.attachment.name | fileDisplayName }}"
                              >
                                <img
                                  class="chat-file-icon"
                                  [src]="(chat?.metadata?.attachment?.name || chat?.metadata?.attachment?.key) | fileTypeIcon"
                                  alt="file icon"
                                />
                                <div class="chat-file-info">
                                  <p class="chat-file-name">
                                    {{ chat.metadata.attachment.name | fileDisplayName }}
                                  </p>
                                  <small class="chat-file-size">{{
                                    formatFileSize(chat.metadata.attachment.size)
                                  }}</small>
                                </div>
                                <span class="material-icons chat-file-download"
                                  >file_download</span
                                >
                              </div>
                              <!-- TEXT MESSAGE -->
                              <p
                                class="message-text"
                                *ngIf="isTextMessage(chat)"
                                [ngClass]="{
                                  'editing-text': chat.metadata?.isDeleted,
                                }"
                              >
                                {{ chat.message }}
                                <small
                                  *ngIf="
                                    chat.metadata?.edited &&
                                    !chat.metadata?.isDeleted
                                  "
                                >
                                  (edited)
                                </small>
                              </p>
                              <div
                                class="bubble-footer"
                                *ngIf="!chat.metadata?.isDeleted"
                              >
                                <span
                                  class="material-icons more-icon"
                                  [matMenuTriggerFor]="mainMenu"
                                >
                                  more_vert
                                </span>
                              </div>
                            </div>
                            <!-- MAIN MENU -->
                            <mat-menu
                              #mainMenu="matMenu"
                              xPosition="before"
                              yPosition="below"
                            >
                              <!-- READ BY (SUB MENU TRIGGER) -->
                              <button
                                mat-menu-item
                                (click)="startReplyMessage(chat)"
                                class="menu-button-own-chat"
                              >
                                Reply
                              </button>
                              <!-- EDIT MESSAGE -->
                              <button
                                mat-menu-item
                                *ngIf="chat.senderId === currectUserId  && canEditMessage(chat)"
                                (click)="startEditMessage(chat)"
                                class="menu-button-own-chat"
                              >
                                <span>Edit</span>
                              </button>
                              <button
                                mat-menu-item
                                *ngIf="chat.senderId === currectUserId  && canEditDeleteMessage(chat)"
                                (click)="deleteMessage(chat)"
                                class="menu-button-own-chat"
                              >
                                Delete
                              </button>

                              <button
                                mat-menu-item
                                *ngIf="!chat.metadata?.isDeleted"
                                (click)="copyMessage(chat)"
                                class="menu-button-own-chat"
                              >
                                <span>Copy</span>
                              </button>
                              <button
                                mat-menu-item
                                *ngIf="isImageMessage(chat) || isFileMessage(chat)"
                                (click)="downloadAttachment(chat)"
                                class="menu-button-own-chat"
                              >
                                <span>Download</span>
                              </button>
                              <button
                                mat-menu-item
                                *ngIf="chat.seenBy?.length"
                                [matMenuTriggerFor]="readByMenu"
                                class="menu-button-own-chat"
                              >
                                <span>Read by ({{ chat.seenBy.length }})</span>
                              </button>
                            </mat-menu>
                            <!-- READ BY SUB MENU -->
                            <mat-menu
                              #readByMenu="matMenu"
                              xPosition="before"
                              yPosition="above"
                            >
                              <div
                                class="read-by-item"
                                *ngFor="let seen of chat.seenBy"
                              >
                                {{ seen.name }}
                              </div>
                            </mat-menu>
                          </ng-container>
                          <ng-template #editingState>
                            <p class="message-text mb-1 editing-text">
                              {{ chat.message }}
                            </p>
                          </ng-template>
                        </div>

                        <div
                          class="date-chat"
                          *ngIf="shouldShowTime(item.messages, i)"
                        >
                          <span class="time-text">
                            {{ chat.messageDate | date: "shortTime" }}
                          </span>
                        </div>
                      </div>
                      <div
                        class="d-flex align-items-center bubble-footer"
                        *ngIf="
                          chat?.userName == loggedInUsername &&
                          shouldShowTime(item.messages, i) &&
                          isLastMessageOverall(chat)
                        "
                      >
                        <!-- <span class="time-text">
                  {{ chat.messageDate | date : "shortTime" }}
                </span>
                <div class="check-icon-chat">
                  <ng-container *ngIf="isMessageSeen(chat); else sent">
                    ✔✔
                  </ng-container>
                  <ng-template #sent> ✔ </ng-template>
                </div> -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          <div
          class="new-messages-pill"
          *ngIf="hasNewMessages"
          (click)="scrollToNewMessages()"
        >
          <span class="material-icons new-msg-arrow">arrow_downward</span>
          <span class="new-msg-text">
            {{ newMessagesCount }} new message{{ newMessagesCount > 1 ? 's' : '' }}
          </span>
        </div>
            <div class="chat-footer">
              <div class="doc-show chat-drop-zone"
                [class.drag-over]="isDraggingAttachment"
                (dragenter)="onAttachmentDragEnter($event)"
                (dragover)="onAttachmentDragOver($event)"
                (dragleave)="onAttachmentDragLeave($event)"
                (drop)="onAttachmentDrop($event)">
                <div class="text-with-action-ic">
                  <div
                    class="reply-preview flex-direction-row"
                    *ngIf="replyToMessage"
                  >
                    <div class="reply-content">
                      <strong>{{ replyToMessage.senderName }}</strong>
                      <p>{{ replyToMessage.message }}</p>
                    </div>
                    <span
                      class="material-icons close-icon"
                      (click)="cancelReplyMessage()"
                    >
                      close
                    </span>
                  </div>

                  <!-- PENDING ATTACHMENTS -->
                  <div
                    class="pending-attachments"
                    *ngIf="pendingAttachments.length"
                  >
                    <div
                      class="pending-attachment-item"
                      *ngFor="let att of pendingAttachments"
                    >
                      <img
                        *ngIf="att.isImage && att.previewUrl"
                        class="pending-thumb"
                        [src]="att.previewUrl"
                        alt=""
                      />
                      <img
                        *ngIf="!att.isImage || !att.previewUrl"
                        class="pending-file-icon"
                        [src]="(att.name || att.key) | fileTypeIcon"
                        alt="file icon"
                      />
                      <div class="pending-info">
                        <p class="pending-name">{{ att.name }}</p>
                        <small class="pending-size">{{
                          formatFileSize(att.size)
                        }}</small>
                      </div>
                      <mat-spinner
                        *ngIf="att.status === 'uploading'"
                        diameter="16"
                        class="pending-spinner"
                      ></mat-spinner>
                      <span
                        class="material-icons pending-status-error"
                        *ngIf="att.status === 'error'"
                        title="{{ att.error }}"
                        >error</span
                      >
                      <span
                        class="material-icons pending-close"
                        (click)="removePendingAttachment(att.id)"
                        >close</span
                      >
                    </div>
                  </div>

                  <div class="d-flex align-items-center gap-10 input-send-wrapper">
                    <mat-form-field
                      class="message-input-box"
                      appearance="outline"
                      [class.chat-error-field]="_emptyMessageError"
                    >
                      <input
                        #box
                        matInput
                        autocomplete="off"
                        [(ngModel)]="editedText"
                        (ngModelChange)="_emptyMessageError = false"
                        [placeholder]="
                          editingMessageId
                            ? 'Edit message...'
                            : 'Type a new message'
                        "
                        (keyup.enter)="onSendOrEdit(box)"
                      />
                      <button
                        type="button"
                        mat-icon-button
                        matSuffix
                        class="attach-inside-btn"
                        (click)="inputFile.click(); $event.preventDefault(); $event.stopPropagation()"
                        title="Attach files"
                      >
                        <span class="material-icons">attach_file</span>
                      </button>
                    </mat-form-field>

                    <!-- SEND BUTTON -->
                    <div class="btn-send d-flex align-items-center">
                      <ng-container *ngIf="editingMessageId; else sendMode">
                        <button
                          class="btn rounded_btn large_btn green_btn mr-2"
                          (click)="onSendOrEdit(box)"
                        >
                          Update
                        </button>

                        <button
                          class="btn rounded_btn large_btn"
                          (click)="cancelEdit()"
                        >
                          Cancel
                        </button>
                      </ng-container>

                      <!-- SEND MODE -->
                      <ng-template #sendMode>
                        <button
                          [disabled]="hasAnyPendingUpload || (!box.value?.trim() && !pendingAttachments.length)"
                          class="btn rounded_btn large_btn green_btn"
                          (click)="onSendOrEdit(box)"
                        >
                          <span class="sm-text-none">Send</span>
                          <i class="material-icons sm-none">send</i>
                        </button>
                      </ng-template>
                    </div>
                  </div>

                  <div *ngIf="_emptyMessageError" class="red_text" style="font-size:12px; margin-top:2px;">
                    Please type a message or attach a file to continue.
                  </div>
                  <div *ngIf="isDraggingAttachment" class="drop-hint-text pb-2">
                    Drop files here to upload
                  </div>
                </div>
              </div>
              <input
                type="file"
                #inputFile
                class="hidden-file-input"
                multiple
                accept=".jpg,.jpeg,.png,.gif,.webp,.bmp,.svg,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,.csv,.zip,image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,text/plain,text/csv,application/zip,application/x-zip-compressed"
                (change)="onFileSelected($event)"
              />
            </div>
          </div>
          <!-- People Panel -->
          <div class="chat-right-panel" [class.open]="showGroupInfo">
            <div class="people-header">
              <span class="people-title">Participants</span>
              <span class="material-icons close-icon" (click)="toggleGroupInfo()">close</span>
        </div>
               <div class="people-count">
          {{ chatMemberName?.length || 0 }}
             member{{ chatMemberName?.length !== 1 ? 's' : '' }}
            </div>
            <div class="member-list">
              <div class="member-row people-item" *ngFor="let item of chatMemberName">
              <div class="people-item-left">
                <div class="avatar-wrap">
                  <img 
                    [src]="item.logo || 'assets/images/person-ic.jpg'" 
                    class="avatar-img"
                    onerror="this.onerror=null; this.src='assets/images/person-ic.jpg';" 
                  />
                        <span
                  class="presence-dot"
                  [class.presence-online]="item.isOnline"
                  [class.presence-offline]="!item.isOnline"
                ></span>
                </div>
                <div class="people-info">
                  <span class="people-name">{{ item.name }}</span>
                  <span class="people-role">{{ item.role }}</span>
                  <!-- <span class="people-company" *ngIf="user.companyName">
                    {{ user.companyName }}
                  </span> -->
                </div>
              </div>
               
              </div>
            </div>
          </div>

          <!-- Search Panel -->
          <div
            class="chat-right-panel search-panel"
            [class.open]="showSearchPanel"
          >
            <div class="panel-header">
              <span>Search Messages</span>
              <span
                class="material-icons close-icon"
                (click)="toggleSearchPanel()"
                (click)="clearSearch()"
              >
                close
              </span>
            </div>
            <div class="member-list">
              <!-- SEARCH BAR -->
              <div class="chat-search">
                <mat-form-field
                  appearance="outline"
                  class="w-full search-chat-input"
                >
                  <input
                    matInput
                    type="text"
                    [(ngModel)]="searchKeyword"
                    (keyup.enter)="onSearchMessages()"
                    placeholder="Enter a search keyword"
                  />
                  <button
                    mat-icon-button
                    matSuffix
                    *ngIf="!searchKeyword"
                    disabled
                  >
                    <mat-icon>search</mat-icon>
                  </button>
                  <button
                    mat-icon-button
                    matSuffix
                    *ngIf="searchKeyword && !isSearching"
                    (click)="onSearchMessages()"
                  >
                    <mat-icon>arrow_forward</mat-icon>
                  </button>

                  <!-- Clear icon -->
                  <button
                    mat-icon-button
                    matSuffix
                    *ngIf="isSearching && searchKeyword"
                    (click)="clearSearch()"
                  >
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </div>

              <!-- SEARCH RESULTS -->
              <ng-container *ngIf="!isSearching && searchResults.length">
                <div
                  class="user-chat-row search-result"
                  *ngFor="let chat of searchResults"
                  (click)="jumpToSearchMessage(chat)"
                >
                  <div class="message-bubble other-bubble">
                    <strong>{{ chat.sender?.name }}</strong>
                    <p class="message-text">{{ chat.message }}</p>
                    <small class="time-text">
                      {{ chat.messageDate | date: "short" }}
                    </small>
                  </div>
                </div>
              </ng-container>
              <div class="loader-center" *ngIf="isSearching">
                <mat-spinner diameter="30"></mat-spinner>
                <p>Searching messages…</p>
              </div>
              <!-- FIRST TIME SEARCH -->
              <div
                class="empty-search-state"
                *ngIf="!hasSearched && !isSearching"
              >
                <mat-icon class="empty-search-icon">search</mat-icon>
                <h3>No search yet</h3>
                <p>Type a keyword above to search messages in this chat</p>
              </div>
              <!-- NO RESULTS -->
              <div
                class="no-results"
                *ngIf="
                  hasSearched &&
                  !isSearching &&
                  searchKeyword &&
                  !searchResults.length
                "
              >
                No results found in this chat. Check for spelling and try
                another keyword.
              </div>
            </div>
          </div>

          <!-- Contract Detail Panel -->
          <div
            class="chat-right-panel contract-panel"
            [class.open]="showContractPanel"
          >
            <div class="panel-header">
              <span>Contract Information</span>
              <span
                class="material-icons close-icon"
                (click)="toggleContractPanel()"
              >
                close
              </span>
            </div>
            <div class="member-list">
              <div *ngIf="!data.staff" class="chat-contract-info">
                <div class="chat-contract-listing">
                  <div class="chat-contract-listing-inner">
                    <label class="mr-2">Active Contracts:</label>
                    <span class="contract-value">{{ data.activeLoads }}</span>
                  </div>
                  <div class="chat-contract-listing-inner">
                    <label class="mr-2">Completed Contracts:</label>
                    <span class="contract-value">{{
                      data.completedLoads
                    }}</span>
                  </div>
                </div>
              </div>
              <div *ngIf="data.staff" class="no-results">
                No contract information available
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
